module.exports = __webpack_public_path__ + "static/media/morePatients.4f7ac750.svg";